import Drawer from "@material-ui/core/Drawer";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { instance } from "Actions/AxiosInstance";
import {
  RightDrawer,
  setPreview as setPreviewAction,
} from "Actions/commonAction";
import { GetMasterData } from "Actions/MasterCodeAction";
import userIcon from "Assets/newicons/user/employees/outline/employees-outline-16px.svg";
import classNames from "classnames";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DrawerHeader from "Component/Headers/drawerHeader";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import PendingReviews from "./PendingReviews";
import Preferences from "./Preferences";
import Results from "./Results";

const styles = () => ({
  drawerPaper: {
    width: "40%",
  },
  table: {
    width: "100%",
  },
  TableCell: {
    padding: "14px 16px 14px 16px",
    borderBottom: "none",
  },
  TableRow: {
    borderRadius: 4,
  },
});

let CALLAPI = true;

class Review extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      value: 0,
      statusList: [],
      performcycles: [],
      preferenceopen: false,
      forms: [],
      empList: [],
      bempList: [],
      threecodes: [],
      fourcodes: [],
      fivecodes: [],
      typeone: [],
      typetwo: [],
      typethree: [],
      typefour: [],
      typefive: [],
      statusid: 1,
      tabId: 0,
      offset: 0,
      limit: 8,
      totalcount: 1,
      cycleid: null,
      searchValue: "",
      selectedempid: null,
      datareceived: false,
    };

    this.handleTabChange = this.handleTabChange.bind(this);
    this.HelperSliderFlag = this.HelperSliderFlag.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getForms = this.getForms.bind(this);
    this.clearForms = this.clearForms.bind(this);
    this.handleVerticalChange = this.handleVerticalChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const status = await GetMasterData("ReviewFormStatus");
    const performcycle = await instance.get("perform/getsubperformcycle");
    const data1 = await instance.get(`perform/getratingscale`);
    const threecodes = [];
    const fourcodes = [];
    const fivecodes = [];
    const typeone = [];
    const typetwo = [];
    const typethree = [];
    const typefour = [];
    const typefive = [];

    const threepoint = data1.data.result.find(
      (rate) => rate.ratingscaletypeid == 1,
    );
    threepoint &&
      Object.keys(threepoint).forEach((key) => {
        if (
          key == "oneunicode" ||
          key == "twounicode" ||
          key == "threeunicode"
        ) {
          threecodes.push(threepoint[key]);
        }
        if (key == "scaleone" || key == "scaletwo" || key == "scalethree") {
          typeone.push(threepoint[key]);
        }
      });
    const fourpoint = data1.data.result.find(
      (rate) => rate.ratingscaletypeid == 2,
    );
    fourpoint &&
      Object.keys(fourpoint).forEach((key) => {
        if (
          key == "oneunicode" ||
          key == "twounicode" ||
          key == "threeunicode" ||
          key == "fourunicode"
        ) {
          fourcodes.push(fourpoint[key]);
        }
        if (
          key == "scaleone" ||
          key == "scaletwo" ||
          key == "scalethree" ||
          key == "scalefour"
        ) {
          typetwo.push(fourpoint[key]);
        }
      });
    const fivepoint = data1.data.result.find(
      (rate) => rate.ratingscaletypeid == 3,
    );
    fivepoint &&
      Object.keys(fivepoint).forEach((key) => {
        if (
          key == "oneunicode" ||
          key == "twounicode" ||
          key == "threeunicode" ||
          key == "fourunicode" ||
          key == "fiveunicode"
        ) {
          fivecodes.push(fivepoint[key]);
        }
        if (
          key == "scaleone" ||
          key == "scaletwo" ||
          key == "scalethree" ||
          key == "scalefour" ||
          key == "scalefive"
        ) {
          typethree.push(fivepoint[key]);
        }
      });
    const sevenpoint = data1.data.result.find(
      (rate) => rate.ratingscaletypeid == 4,
    );
    sevenpoint &&
      Object.keys(sevenpoint).forEach((key) => {
        if (
          key == "scaleone" ||
          key == "scaletwo" ||
          key == "scalethree" ||
          key == "scalefour" ||
          key == "scalefive" ||
          key == "scalesix" ||
          key == "scaleseven"
        ) {
          typefour.push(sevenpoint[key]);
        }
      });
    const tenpoint = data1.data.result.find(
      (rate) => rate.ratingscaletypeid == 5,
    );
    tenpoint &&
      Object.keys(tenpoint).forEach((key) => {
        if (
          key == "scaleone" ||
          key == "scaletwo" ||
          key == "scalethree" ||
          key == "scalefour" ||
          key == "scalefive" ||
          key == "scalesix" ||
          key == "scaleseven" ||
          key == "scaleeight" ||
          key == "scalenine"
        ) {
          typefive.push(tenpoint[key]);
        }
      });
    this.setState(
      {
        threecodes,
        fourcodes,
        fivecodes,
        typeone,
        typetwo,
        typethree,
        typefour,
        typefive,
        statusList: status.data.result,
        performcycles: performcycle.data.result.map((x) => ({
          ...x,
          displayvalue: x.performcycledurationid,
        })),
        statusid: 1,
        value: this.props.history.location.pathname.includes("pendingreviews")
          ? 0
          : this.props.history.location.pathname.includes("submittedreviews")
          ? 1
          : 2,
        cycleid:
          performcycle.data.result &&
          performcycle.data.result.find((x) => x.performcycletypeid == 2) &&
          performcycle.data.result.find((x) => x.performcycletypeid == 2)
            .performcycledurationid,
      },
      () => {
        this.state.value == 2 ? this.getForms() : this.get360Employees();
      },
    );
  }

  handleTabChange(event, value) {
    this.setState(
      { value, forms: [], statusid: 1, offset: 0, totalcount: 1 },
      () => {
        this.getForms();
        this.props.history.push(
          `/${
            value == 0
              ? "pendingreviews"
              : value == 1
              ? "submittedreviews"
              : "myresults"
          }`,
        );
      },
    );
  }

  handleVerticalChange(id) {
    this.setState(
      {
        tabId: id,
        statusid: id == 1 ? 2 : 1,
        forms: [],
        offset: 0,
        totalcount: 1,
      },
      () => {
        (id == 0 || id == 1) && this.getForms();
      },
    );
  }

  clearForms(employeeid) {
    this.setState(
      {
        offset: 0,
        totalcount: 1,
        forms: [],
      },
      () => {
        this.getForms({ employeeid });
      },
    );
  }

  getForms(emp, tabtypeid, panelid, selectedstatusid) {
    // debugger;
    this.setState(
      {
        selectedempid: (emp && emp.employeeid) || (emp && emp.displayvalue),
        empforms: null,
        forms:
          (emp && emp.employeeid) || (emp && emp.displayvalue)
            ? []
            : panelid
            ? []
            : this.state.forms,
        // forms: panelid == 2 && [],
        offset:
          (emp && emp.employeeid) || (emp && emp.displayvalue)
            ? 0
            : panelid
            ? 0
            : this.state.offset,
        totalcount:
          (emp && emp.employeeid) || (emp && emp.displayvalue)
            ? 1
            : panelid
            ? 1
            : this.state.totalcount,
      },
      () => {
        const {
          statusid,
          value,
          selectedempid,
          offset,
          limit,
          totalcount,
          forms,
        } = this.state;

        const data = {
          accesstypeid: 1,
          // tabtypeid: value == 0 ? 1 : value == 4 ? 1 : 2,
          // tabtypeid: 1,
          tabtypeid,
          performcycledurationid: this.state.cycleid,
          statusid:
            value == 0
              ? 1
              : value == 1
              ? selectedstatusid
              : value == 2
              ? 2
              : "",
          offset,
          limit,
          employeeid: selectedempid ? selectedempid : null,
          isparticipant: true,
          isbarrequired: true,
        };
        // debugger;
        if (CALLAPI) {
          if (totalcount && offset < totalcount && forms.length < totalcount) {
            CALLAPI = false;
            instance
              .post("perform/getemployeereview", data)
              .then((result) => {
                let ListData = [];
                CALLAPI = true;
                result.data.result.length > 0
                  ? (ListData = [...forms, ...result.data.result])
                  : (ListData = forms);
                this.setState({
                  forms: ListData,
                  datareceived: true,
                  offset: offset + this.state.limit,
                  totalcount: ListData[0] ? ListData[0].fullcount : 1,
                });
              })
              .catch((error) => {
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
              });
          }
        }
      },
    );
  }

  get360Employees() {
    const { cycleid } = this.state;
    const data = {
      performcycledurationid: this.state.cycleid,
      employeeid: null,
    };
    if (cycleid) {
      instance
        .post("perform/employeeunderreviewlistbyparticipant", data)
        .then((result) => {
          this.setState({
            empList: result.data.result,
            bempList: result.data.result,
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  handleChange(key, value) {
    this.setState(
      {
        [key]: value,
        forms: [],
        offset: 0,
        totalcount: 1,
      },
      () => {
        this.getForms(
          this.state.value == 1
            ? { employeeid: this.state.selectedempid }
            : null,
        );
        this.get360Employees();
      },
    );
  }

  handleSearch(e) {
    const { bempList, empList } = this.state;
    const filterList = empList.filter(
      (item) =>
        item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      empList: e.target.value ? filterList : bempList,
    });
  }

  HelperSliderFlag(side, flag, text, config, event) {
    event.stopPropagation();
    // this.setState({ HelperSlider: flag })
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }
    // this.props.RightDrawer({ drawerdata: text, open: flag });
    this.props.RightDrawer({
      drawerdata: text,
      open: side,
      side: flag,
      configid: config,
    });
    // this.props.RightDrawer({ drawerdata: this.state.EmpList, open: flag });
  }

  render() {
    const { value, empList } = this.state;
    const { classes } = this.props;
    const isSpecialAccess =
      this.props.history.location.pathname.includes("app");
    const migrateperformance = this.props.login.migration.find(
      (x) => x.moduletypeid == 5,
    );
    return (
      <div className="content-outer-wrapper">
        <div
          style={{
            position: "sticky",
            top: 54,
            zIndex: 1,
            height: 34,
            background: "#fff",
          }}
        ></div>
        <div
          className="common-menubar-header-sticky"
          style={{ marginTop: -34 }}
        >
          <p className="large-text-dark-secondary t-bold margin-bottom-16">
            Performance reviews
          </p>
          <div
            className="display-flex"
            style={{ justifyContent: "space-between" }}
          >
            <Tabs
              value={this.state.value}
              onChange={this.handleTabChange}
              indicatorColor="#fff"
              textColor="primary"
              scrollButtons="auto"
            >
              {/* {GetFeature("zero") && (
                <Tab
                  label="Zero°"
                  disabled={!GetFeature("epdegree")}
                  className={`tabheading ${
                    this.props.history.location.pathname.includes("zero")
                      ? "active-tab1"
                      : "inactive-tab1"
                  } `}
                />
              )}
              {GetFeature("epdegree") && (
                <Tab
                  label="360°"
                  disabled={!GetFeature("zero")}
                  className={`tabheading ${
                    this.props.history.location.pathname.includes("360")
                      ? "active-tab1"
                      : "inactive-tab1"
                  } `}
                />
              )} */}
              <Tab
                label="Pending reviews"
                className={`tabheading ${
                  this.props.history.location.pathname.includes(
                    "pendingreviews",
                  )
                    ? "active-tab1"
                    : "inactive-tab1"
                } `}
                style={{ minHeight: 56 }}
              />
              <Tab
                label="Submitted reviews"
                className={`tabheading ${
                  this.props.history.location.pathname.includes(
                    "submittedreviews",
                  )
                    ? "active-tab1"
                    : "inactive-tab1"
                } `}
                style={{ minHeight: 56 }}
              />
              <Tab
                label="My results"
                className={`tabheading ${
                  this.props.history.location.pathname.includes("myresults")
                    ? "active-tab1"
                    : "inactive-tab1"
                } `}
                style={{ minHeight: 56 }}
              />
            </Tabs>
            <div className="display-flex">
              <span
                className="inline-block margin-right-8"
                style={{ width: 240 }}
              >
                <DynamicForm
                  fields={selectinputconverter({
                    value: this.state.cycleid,
                    options: this.state.performcycles,
                    placeholder: "Select cycle",
                    label: "",
                  })}
                  onChange={(id) => this.handleChange("cycleid", id)}
                />
              </span>
              <div
                className="rounded-rectangle-div padding8 display-flex"
                style={{
                  height: 22,
                  padding: "8px 16px",
                  alignItems: "center",
                }}
                onClick={() => this.setState({ preferenceopen: true })}
              >
                <img
                  src={userIcon}
                  className="margin-right-8"
                  height="16"
                ></img>
                <p className="normal-dark">My Participants</p>
              </div>
            </div>
          </div>
          <div className="tab-border" style={{ top: -2 }}></div>
        </div>

        {migrateperformance && migrateperformance.isenable && (
          <div
            style={{
              float: "right",
              width: 230,
              marginTop: 58,
              color: "#057cff",
              fontWeight: 400,
              marginRight: 24,
              cursor: "pointer",
            }}
            onClick={() => {
              window.open(migrateperformance.oldurl);
            }}
          >
            View performce in sumHR 2.0
          </div>
        )}
        <div className="" style={{ padding: "0px 2px" }}>
          {(value == 0 || value == 1) && (
            <PendingReviews
              {...this.state}
              {...this.props}
              isSpecialAccess={isSpecialAccess}
              cycleid={this.state.cycleid}
              getForms={this.getForms}
              clearForms={this.clearForms}
              get360Employees={this.get360Employees}
              handleChange={this.handleChange}
              empList={empList}
              datareceived={this.state.datareceived}
            />
          )}

          {value == 2 && (
            <Results
              {...this.state}
              {...this.props}
              isSpecialAccess={isSpecialAccess}
              getForms={this.getForms}
              handleChange={this.handleChange}
              datareceived={this.state.datareceived}
            />
          )}
        </div>
        <Drawer
          anchor="right"
          open={this.state.preferenceopen}
          onClose={() =>
            this.setState({
              preferenceopen: false,
            })
          }
          classes={{
            paper: classNames(classes.drawerPaper, "planner-drawer padding15"),
          }}
        >
          <DrawerHeader
            header="Participants"
            isbackarrow={false}
            closeDrawer={() =>
              this.setState({
                preferenceopen: false,
              })
            }
          />
          <Preferences />
        </Drawer>
      </div>
    );
  }
}

const VerticalTabs = withStyles(() => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles(() => ({
  labelContainer: {
    padding: "6px 8px",
  },
  label: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  icon: {
    display: "inline-black",
  },
}))(Tab);

function TabContainer(props) {
  return <div>{props.children}</div>;
}

const mapStateToProps = (state) => ({
  login: state.AuthenticationAction.login,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
      RightDrawer: (data) => RightDrawer(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(withRouter(Review))));
